import React, { useState } from "react";
import { MenuItem, Select } from "@mui/material";
import { Box } from "@mui/system";
import { DrawerStateKinds, updateTripRouteId, useDrawerState } from "../../features/Drawer/drawerSlice";
import { useDispatch } from "react-redux";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import {
    adminOverrideRoutesToDisplay,
    setSelectedRoute,
    useAllRoutes,
    useSelectedRoute
} from "../../features/riskViewer/riskViewerSlice";
import RankingVectorModal from "./RankingVectorModal";
import { ADMIN_MULTISTART_VARIATION, ADMIN_RANKING_VECTOR } from "../UserVisibleStrings";
import { RouteId } from "../../generated/gpb/api/id";
import { filterRawRouteResults, selectRouteToView } from "../trips/tripUtils";
import { useLazyGetTripQuery } from "../../services/routing";


const AdminControls = ( ) =>
{
    const drawerState = useDrawerState();
    const tripData = ( drawerState.kind === DrawerStateKinds.MultistartSelection || drawerState.kind === DrawerStateKinds.TripResults )
        ? drawerState.trip
        : undefined;

    const allRoutes = useAllRoutes();
    const dispatch = useDispatch();
    const selectedRoute = useSelectedRoute();
    const selectedRouteVariationTag = allRoutes?.find( route => route.routeId?.hexString === selectedRoute?.hexString )?.variationTag;
    const [ triggerGetTrip ] = useLazyGetTripQuery();

    const handleRotateRoute = ( routeIdHex: string ) =>
    {
        //we conditionally handle the multistart selection case here, but we could potentially remove this conditional
        //handling. In general, we don't want to introduce branching and complexity to accomodate admins
        dispatch( setSelectedRoute( allRoutes !== undefined ? { hexString: routeIdHex } as RouteId : undefined ) );
        dispatch( updateTripRouteId( { routeId: allRoutes !== undefined ? { hexString: routeIdHex } as RouteId : undefined } ) );
        if ( allRoutes !== undefined && ( drawerState.kind !== DrawerStateKinds.MultistartSelection ) )
        {
            const newRoutesTodisplay = filterRawRouteResults( allRoutes, { hexString: routeIdHex } as RouteId, true );
            if ( newRoutesTodisplay !== undefined )
            {
                dispatch( adminOverrideRoutesToDisplay( newRoutesTodisplay.map( each => each.element ) ) );
            }
        }
    };

    const [ displayVectorModal, setDisplayVectorModal ] = useState<boolean>( false );
    return (
        <Box component = "fieldset">
            <legend>Admin Controls</legend>
            {tripData?.userId !== undefined &&
                <React.Fragment>
                    <span>This trip was generated by user </span>
                    <span>{tripData?.userId.wordpressId}</span>
                </React.Fragment>}
            {tripData !== undefined && tripData.parentIdHex !== undefined && tripData.parentIdHex !== "" && (
                <div>
                    <span>This trip was derived from trip {tripData.parentIdHex}</span>
                    <Button onClick = {async () =>
                    {
                        if ( tripData?.parentIdHex === undefined ) return;

                        try
                        {
                            const tripId = tripData.parentIdHex;
                            const result = await triggerGetTrip( tripId ).unwrap();
                            selectRouteToView( result, dispatch, true );
                        }
                        catch ( err )
                        {
                            console.error( "Failed to fetch trip data:", err );
                        }
                    }}
                    >
                        View
                    </Button>
                </div>
            )}

            {allRoutes !== undefined && allRoutes.length >= 2 &&
                <React.Fragment>
                    <Typography sx = {{ padding: "0px 6px" }}>
                        {ADMIN_MULTISTART_VARIATION}
                    </Typography>
                    <Select value = {selectedRoute?.hexString} onChange = {( menuItem ) => handleRotateRoute( menuItem.target.value as string )}
                        sx = {{ padding: "0px 6px" }}
                    >
                        {allRoutes.map( each =>
                        {
                            return <MenuItem key = {each?.routeId?.hexString} value = {each?.routeId?.hexString}>{each?.variationTag}</MenuItem>;
                        } )}
                    </Select>
                    <Button onClick = {() => setDisplayVectorModal( true )} sx = {{ padding: "0px 6px" }}>
                        {ADMIN_RANKING_VECTOR}
                    </Button>
                </React.Fragment>}
            <RankingVectorModal displayVectorModal = {displayVectorModal} setDisplayVectorModal = {setDisplayVectorModal}
                routesToDisplay = {allRoutes} selectedRouteVariationtag = {selectedRouteVariationTag}
            />

        </Box>
    );
};

export default AdminControls;
